import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import TripsSideBarTop from '../components/tripcenter/TripsSideBarTop';
import TripsSideBarBody from '../components/tripcenter/TripsSideBarBody';
import RoutesView from '../components/tripcenter/RoutesView';
import TrackRouteSideBarBody from '../components/tripcenter/TrackRouteSideBarBody';
import RoutesSideBarBody from '../components/tripcenter/RoutesSideBarBody';
import TripReport from '../components/tripcenter/tripComponents/TripReport';
import RouteBuilderModal from '../components/tripcenter/routeBuilderComponents/RouteBuilderModal';

import { liveTrackinglayoutSelector } from '../features/layout/layoutSlice';
import { setMapControl } from '../features/map/mapSlice';
import { selectViewType, setViewType } from '../features/tripcenter/tripViewSlice';
import { selectRouteMaker, setRouteMaker } from '../features/tripcenter/routeSlice';
import { showTripReportSelector } from '../features/tripcenter/tripControlSlice';

const TripCenter = () => {
    const dispatch = useDispatch();
    const viewType = useSelector(selectViewType);
    const routeMaker = useSelector(selectRouteMaker);
    const showTripReport = useSelector(showTripReportSelector);
    const dimentions = useSelector(liveTrackinglayoutSelector);

    useEffect(() => {
        dispatch(setMapControl('tripCenter'));
        dispatch(setViewType('tripList'));
        return () => {
            dispatch(setMapControl('asset'));
            dispatch(setRouteMaker(null));
        }
    }, [dispatch])
    //console.log("Current View Type: ", viewType, "Route Maker: ", routeMaker);

    return (
        <>
            <div style={dimentions.sidebar}>
                <div style={dimentions.tripsTop}>
                    <TripsSideBarTop />
                </div>
                <div style={{ ...dimentions.tripsListView, overflow: 'auto' }}>
                    {
                        viewType === 'tripList' && <TripsSideBarBody />
                    }
                    {
                        viewType === 'routes' && routeMaker === null && <RoutesView />
                    }
                    {/*
                        viewType === 'routes' && routeMaker === 'google' && <GoogleRouteSideBarBody />
                    */}

                    {
                        viewType === 'routes' && routeMaker === 'track' && <TrackRouteSideBarBody />
                    }
                </div>
                {showTripReport && <div style={dimentions.tripReportView}>
                    <TripReport />
                </div>}
            </div>

            {/* Route Builder Modal - will show/hide itself based on routeMaker state */}
            <RouteBuilderModal />
        </>
    );
}

export default TripCenter;